// ** React Imports
import { useEffect } from 'react'

// ** React Router Imports
import { useLocation, useNavigate } from 'react-router-dom'

// ** Utils Imports
import { API } from '../../utility/API'
import { useDispatch } from 'react-redux'
import { showKYCReminderModal } from '../../modules/modals/kyc/helpers'
import { setWarningModalData, setWarningModalOpen } from '../../modules/modals/warning/redux/warningModalSlice'
import { MAINTENANCE_MODE } from '../../constants/maintenance'

const AxiosInterceptor = ({ children }) => {
  const dispatch = useDispatch()
  // ** Constants
  const apiEndpointsToIgnore = [
    'authenticate/resource/users/me' // Ignore redirection when the user is in login
    // 'trading/market/orders', // Ignore with the condition of the current page is the exchange page /trade
    // 'trading/account/balances', // Ignore balances API when in exchange page
    // 'trading/market/orders',
    // 'trading/public/markets'
  ]

  // ** Hooks
  const navigate = useNavigate()
  const location = useLocation()

  /**
   * NOTE: This global flag/booleab is used to track
   * wheter the user got redirected and stop redirection
   * of other 401 API calls
   */
  let isInterceptorCalled = false

  useEffect(() => {
    // Block requests in maintenance mode
    const reqInterceptor = config => {
      if (MAINTENANCE_MODE) {
        return Promise.reject(new Error('APPLICATION_UNDER_MAINTENANCE'))
      }
      return config
    }

    // Proceed with success calls
    const resInterceptor = response => {
      return response
    }

    // Check for error calls
    const errInterceptor = error => {
      const pathname = location.pathname
      const apiEndpoint = error.config.url

      // ** URL Params
      const urlParams = new URLSearchParams(location.search)
      const redirectUrl = urlParams.get('redirect_url')
      // console.log(error.response)
      // console.log(error.response?.data?.errors[0])
      const ErrorMessage = error.response?.data?.errors[0] ?? ''
      if (ErrorMessage.includes("not_permitted")) {
        dispatch(showKYCReminderModal())
        // console.log("WROEKED")
      }
      if (ErrorMessage.includes("decode_and_verify")) {
        dispatch(setWarningModalData({
          title: "Email Verification Required",
          subtitle: "Please verify your email to proceed",
          callback: () => navigate('/email-verification-required')
        }))
        dispatch(setWarningModalOpen(true))
      }
      // Unauthorized case  
      if (!isInterceptorCalled && error.response && error.response.status === 401) {
        // Set the flag to true to prevent further interceptor calls
        isInterceptorCalled = true
        if (
          apiEndpoint.split('?')[0].includes('authenticate/resource/users/me') ||
          !apiEndpointsToIgnore.includes(apiEndpoint.split('?')[0])
        ) {
          // Redirect to login if unauthorized
          // if (!redirectUrl) {
          //   handleUnauthorized(navigate, location.pathname)
          //   isInterceptorCalled = false
          // }
        }
      }
      //   else {
      //     toast.error('Something went wrong')
      //   }
      // Pass the error
      return Promise.reject(error)
    }

    const interceptor = API.interceptors.response.use(resInterceptor, errInterceptor)
    const requestInterceptor = API.interceptors.request.use(reqInterceptor)

    return () => {
      API.interceptors.response.eject(interceptor)
      API.interceptors.request.eject(requestInterceptor)
    }
  }, [])

  return <>{children}</>
}

export default AxiosInterceptor
